<div
  class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] flex flex-col min-h-0 shadow-sm mx-auto"
  [style.height]="computedHeight">
  <div
    class="flex flex-col justify-between gap-5 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center dark:border-gray-800">
    <div class="relative flex-1 sm:flex-auto" *ngIf="showSearch">
      <span class="absolute top-1/2 left-4 -translate-y-1/2 text-gray-500 dark:text-gray-400">
        <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M3.04199 9.37363C3.04199 5.87693 5.87735 3.04199 9.37533 3.04199C12.8733 3.04199 15.7087 5.87693 15.7087 9.37363C15.7087 12.8703 12.8733 15.7053 9.37533 15.7053C5.87735 15.7053 3.04199 12.8703 3.04199 9.37363ZM9.37533 1.54199C5.04926 1.54199 1.54199 5.04817 1.54199 9.37363C1.54199 13.6991 5.04926 17.2053 9.37533 17.2053C11.2676 17.2053 13.0032 16.5344 14.3572 15.4176L17.1773 18.238C17.4702 18.5309 17.945 18.5309 18.2379 18.238C18.5308 17.9451 18.5309 17.4703 18.238 17.1773L15.4182 14.3573C16.5367 13.0033 17.2087 11.2669 17.2087 9.37363C17.2087 5.04817 13.7014 1.54199 9.37533 1.54199Z">
          </path>
        </svg>
      </span>
      <input type="text" [value]="searchTerm" (input)="onSearch(($any($event.target)).value)"
        [placeholder]="searchPlaceholder"
        class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-10 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pr-4 pl-11 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden sm:w-[300px] sm:min-w-[400px] dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30">
    </div>

    <div>
      <ng-content select="[table-actions]"></ng-content>
    </div>
  </div>

  <!-- Counter -->
  <div class="border-b border-gray-200 px-5 py-4 dark:border-gray-800" *ngIf="showCounter">
    <span class="block text-sm font-medium text-gray-500 dark:text-gray-400">
      Total registros:
      <span class="text-gray-800 dark:text-white/90">{{ totalCount }}</span>
    </span>
  </div>

  <!-- Table -->
  <div class="custom-scrollbar overflow-x-auto overflow-y-auto flex-1 min-h-0">
    <table class="w-full table-auto">
      <thead>
        <tr class="border-b border-gray-800 dark:divide-gray-800 dark:border-gray-800">
          <th *ngFor="let col of columns" class="text-left" [ngClass]="[
                'px-5 py-3 text-xs text-gray-600 dark:text-gray-300 tracking-wide',
                stickyHeader ? 'sticky top-0 z-9 bg-white/95 dark:bg-gray-900/90 backdrop-blur' : '',
                col.widthClass || ''
              ]">
            {{ col.header }}
          </th>
        </tr>
      </thead>

      <tbody *ngIf="!loading && rows?.length; else loadingOrEmpty"
        class="divide-x divide-y divide-gray-200 dark:divide-gray-800">
        <tr *ngFor="let row of rows; trackBy: trackBy" class="transition hover:bg-gray-50 dark:hover:bg-gray-900">

          <td *ngFor="let col of columns" class="px-3 py-3 whitespace-nowrap">
            <ng-container *ngIf="col.cell && cellTemplates[col.cell!]; else defaultCell">
              <ng-container *ngTemplateOutlet="cellTemplates[col.cell!]; context: {$implicit: row}"></ng-container>
            </ng-container>
            <ng-template #defaultCell>
              <span class="text-sm text-gray-700 dark:text-gray-400">
                {{ getValue(row, col) }}
              </span>
            </ng-template>
          </td>

        </tr>
      </tbody>

      <ng-template #loadingOrEmpty>
        <tbody>
          <tr *ngIf="loading">
            <td [attr.colspan]="columns.length || 1"
              class="px-5 py-6 text-center text-sm text-gray-500 dark:text-gray-400">
              Cargando...
            </td>
          </tr>
          <tr *ngIf="!loading && (!rows || !rows.length)">
            <td [attr.colspan]="columns.length || 1"
              class="px-5 py-6 text-center text-sm text-gray-500 dark:text-gray-400">
              Sin resultados
            </td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>

  <!-- Footer / Pagination -->
  <div
    class="flex flex-col items-center justify-between border-t border-gray-200 px-5 py-4 sm:flex-row dark:border-gray-800"
    *ngIf="showPagination">
    <div class="pb-3 sm:pb-0">
      <span class="block text-sm font-medium text-gray-500 dark:text-gray-400">
        Mostrando
        <span class="text-gray-800 dark:text-white/90">{{ startItem }}</span>
        a
        <span class="text-gray-800 dark:text-white/90">{{ endItem }}</span>
        de
        <span class="text-gray-800 dark:text-white/90">{{ totalCount }}</span>
      </span>
    </div>

    <div class="flex items-center gap-2">
      <button (click)="prev()" [disabled]="page === 1"
        class="shadow-theme-xs flex items-center gap-2 rounded-lg border border-gray-300 bg-white p-2 text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400">
        <span>
          <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M2.58203 9.99868C2.58174 10.1909 2.6549 10.3833 2.80152 10.53L7.79818 15.5301C8.09097 15.8231 8.56584 15.8233 8.85883 15.5305C9.15183 15.2377 9.152 14.7629 8.85921 14.4699L5.13911 10.7472L16.6665 10.7472C17.0807 10.7472 17.4165 10.4114 17.4165 9.99715C17.4165 9.58294 17.0807 9.24715 16.6665 9.24715L5.14456 9.24715L8.85919 5.53016C9.15199 5.23717 9.15184 4.7623 8.85885 4.4695C8.56587 4.1767 8.09099 4.17685 7.79819 4.46984L2.84069 9.43049C2.68224 9.568 2.58203 9.77087 2.58203 9.99715C2.58203 9.99766 2.58203 9.99817 2.58203 9.99868Z">
            </path>
          </svg>
        </span>
      </button>

      <ul class="hidden items-center gap-0.5 sm:flex">
        <li *ngFor="let n of pagesArray; let i = index">
          <a (click)="goTo(i+1)" href="javascript:void(0)" [class.bg-brand-500]="page === (i+1)"
            [class.text-white]="page === (i+1)"
            class="flex h-10 w-10 items-center justify-center rounded-lg text-sm font-medium hover:bg-brand-500 hover:text-white">
            {{ i + 1 }}
          </a>
        </li>
      </ul>

      <button (click)="next()" [disabled]="page === totalPages"
        class="shadow-theme-xs flex items-center gap-2 rounded-lg border border-gray-300 bg-white p-2 text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400">
        <span>
          <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M17.4165 9.9986C17.4168 10.1909 17.3437 10.3832 17.197 10.53L12.2004 15.5301C11.9076 15.8231 11.4327 15.8233 11.1397 15.5305C10.8467 15.2377 10.8465 14.7629 11.1393 14.4699L14.8594 10.7472L3.33203 10.7472C2.91782 10.7472 2.58203 10.4114 2.58203 9.99715C2.58203 9.58294 2.91782 9.24715 3.33203 9.24715L14.854 9.24715L11.1393 5.53016C10.8465 5.23717 10.8467 4.7623 11.1397 4.4695C11.4327 4.1767 11.9075 4.17685 12.2003 4.46984L17.1578 9.43049C17.3163 9.568 17.4165 9.77087 17.4165 9.99715C17.4165 9.99763 17.4165 9.99812 17.4165 9.9986Z">
            </path>
          </svg>
        </span>
      </button>
    </div>
  </div>
</div>
